export const isLocalhost = true // window.location.host.includes('localhost:')

export const API_KEY = 'YS1UTYKAUBH1R8XU54GT6E1883MPTY8KWH'

export const defaultScan = isLocalhost ? 'https://testnet.bscscan.com' : 'https://bscscan.com'
export const defaultScanApi = isLocalhost ? 'https://api-testnet.bscscan.com' : 'https://api.bsscan.com'

export const cnrAddress = '0xB7D4f13A3639017c653a164336058aac32430B85'
export const greenHouseAddress = '0x850C8983B8056e637cbEEf2fb148ca1a56D2a572'


export const defaultNetwork = isLocalhost ? 97 : 56

export const walletConnectOpts = {
    infuraId: '97a6f1404cf746bbb78a35045d9dd35a', // required TODO add for Kovan/Bsscan // binance not
    network: 'testnet',
    chainId: 97,
    rpc: {
        97: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
        56: 'https://bsc-dataseed.binance.org',
    }
}

export const networksConfig = {
    56: {
        chainId: '0x38',
        code: 'mainnet',
        explorerURL: 'https://bscscan.com',

        metamaskSettings: {
            method: 'wallet_addEthereumChain',
            params: [{
                chainId: '0x38',
                chainName: 'Binance Smart Chain',
                nativeCurrency: {
                    name: 'Binance Coin',
                    symbol: 'BNB',
                    decimals: 8
                },
                rpcUrls: ['https://bsc-dataseed.binance.org'],
                blockExplorerUrls: ['https://bscscan.com']
            }]
        }
    },
    97: {
        chainId: '0x61',
        code: 'testnet',
        explorerURL: 'https://testnet.bscscan.com',

        metamaskSettings: {
            method: 'wallet_addEthereumChain',
            params: [{
                chainId: '0x61',
                chainName: 'Testnet Binance Smart Chain',
                nativeCurrency: {
                    name: 'Binance Coin',
                    symbol: 'BNB',
                    decimals: 8
                },
                rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
                blockExplorerUrls: ['https://testnet.bscscan.com']
            }]
        }
    }
}
